import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/")({
  beforeLoad: () => {
    throw redirect({
      to: "/operator/overview",
      search: { licenseId: undefined, tab: undefined },
    });
  },
  component: () => null,
});
